package com.essntl.features.itinerary.domain.use_case

import com.essntl.features.itinerary.domain.model.ItineraryFilterOptions
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.itinerary.domain.model.ItineraryOrderType
import core.dateformat.utils.parseLocalDateOrNull
import kotlinx.datetime.Clock
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

object SortItineraries {
    operator fun invoke(
        itineraries: List<ItineraryModel>,
        filterOptions: ItineraryFilterOptions,
    ): List<ItineraryModel> {
        return itineraries.filter {
            val titleFilter =
                it.proposal?.title?.contains(filterOptions.searchText.trim(), ignoreCase = true) ?: false

            val shareCodeFilter =
                it.proposal?.shareCode?.contains(filterOptions.searchText.trim(), ignoreCase = true) ?: false

            val selectedFromDate = parseLocalDateOrNull(filterOptions.selectedFromDate)
            val selectedToDate = parseLocalDateOrNull(filterOptions.selectedToDate)
            val fromDate = parseLocalDateOrNull(it.proposal?.fromDate)
            val toDate = parseLocalDateOrNull(it.proposal?.toDate)

            val dateFilter =
                when {
                    selectedFromDate != null &&
                        selectedToDate != null &&
                        fromDate != null &&
                        toDate != null ->
                        fromDate >= selectedFromDate && fromDate <= selectedToDate

                    selectedFromDate != null && fromDate != null ->
                        fromDate >= selectedFromDate

                    selectedToDate != null && toDate != null ->
                        toDate <= selectedToDate

                    else -> true
                }

            val profileFilter = if (filterOptions.selectedProfileIds.isNotEmpty())
                filterOptions.selectedProfileIds.contains(it.proposal?.owner?.id) else
                true

            val completedFilter = if (!filterOptions.completed)
                toDate != null && toDate >= Clock.System.now().toLocalDateTime(TimeZone.UTC).date else
                true

            (titleFilter || shareCodeFilter) &&
                dateFilter &&
                profileFilter &&
                completedFilter
        }.sortedWith(
            when (filterOptions.selectedItineraryOrderType) {
                ItineraryOrderType.Alphabetical -> compareBy<ItineraryModel> { it.proposal?.title?.lowercase() }
                ItineraryOrderType.LastCreated -> compareByDescending<ItineraryModel> { it.proposal?.createdAt }
                ItineraryOrderType.StartDate -> compareBy<ItineraryModel> { it.proposal?.fromDate }
            }.thenByDescending { it.createdAt },
        )
    }
}
